import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
// import WarningIcon from '@mui/icons-material/Warning';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import './WarningPopUp.css';

// eslint-disable-next-line react/prop-types
const WarningPopUp = ({openDialog, handleCloseDialog, dialogMessage}) => {
  return (
    <>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // className="warning-dialog"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" sx={{pb:0}}>
          <Box sx={{display:"flex",justifyContent:"center",width:1}}>
          <WarningAmberRoundedIcon sx={{fontSize: 90}} className="warning-icon" />
          </Box>
        </DialogTitle>
        <DialogContent>
          <div id="alert-dialog-description" className="warning-message">{dialogMessage}</div>
        </DialogContent>
        <DialogActions className='okButton' >
          <Button onClick={handleCloseDialog} autoFocus variant='contained'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default WarningPopUp